export const updateManageReviewerMutation = `mutation UpdateManageReviewer($input: [UpdateReviewerInput]) {
    updateManageReviewer(input: $input) {
        status
        details
        error {
            message
            date
        }
    }
}`